/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionstatussentone3Inputs */

const en_actionstatussentone3 = /** @type {(inputs: Actionstatussentone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent to one favourite`)
};

const de_actionstatussentone3 = /** @type {(inputs: Actionstatussentone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An einen Favoriten geschickt`)
};

/**
* | output |
* | --- |
* | "Sent to one favourite" |
*
* @param {Actionstatussentone3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionstatussentone3 = /** @type {((inputs?: Actionstatussentone3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionstatussentone3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionstatussentone3(inputs)
	return de_actionstatussentone3(inputs)
});
export { actionstatussentone3 as "actionStatusSentOne" }